/*
 * @providesModule RematchDeclinedModal
 *
 */

import React from 'react';
import I18n from 'INTL';
import Label from 'Label';
import PushButton from 'PushButton';
import SkillzStyle from 'SkillzStyle';

import {StyleSheet, View} from 'react-native';
import ModalNavigationController from 'ModalNavigationController';

const {
  fontSizeH2,
  fontSizeH3,
  fontSecondary,
  btnTextColorOne,
  viewCornerRadiusPrimary,
  btnGradientOne,
} = SkillzStyle.fullStyles;

export default class RematchDeclinedModal extends React.Component {
  render(): React.ReactNode {
    return (
      <View style={[StyleSheet.absoluteFill, styles.background]}>
        <View style={styles.modalContainer}>
          <Label style={styles.title} numberOfLines={0}>
            {I18n.message('Your rematch was declined')}
          </Label>
          <PushButton
            style={styles.button}
            onPress={() => {
              ModalNavigationController.hideModal();
            }}
            cornerRadius={viewCornerRadiusPrimary.borderRadius}
            colors={btnGradientOne}
            textStyle={styles.buttonText}
            title={I18n.message('OK')}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  background: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: SkillzStyle.convertToOpacity('#000000', 0.6),
  },

  modalContainer: {
    width: 250,
    backgroundColor: 'white',
    ...viewCornerRadiusPrimary,
  },

  title: {
    marginHorizontal: 10,
    marginVertical: 20,
    textAlign: 'center',
    color: 'black',
    ...fontSizeH3,
  },

  button: {
    height: 36,
    width: 120,
    alignSelf: 'center',
    marginBottom: 20,
  },

  buttonText: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...fontSizeH2,
  },
});
